import { matchesActiveSubtype } from '../../../intradaySubtype.helpers'
import type { Direction, UnitColumn } from '../BidInputTable.types'
import { type ConfiguredPosition, isConfiguredPositionsValid } from './BidInputValidation.helper'

export function getColumnUnitKey(positionId: string, tagId: string): string {
  return `${positionId}::${tagId}`
}

export function getActiveSubtypeTags(
  position: ConfiguredPosition,
  activeSubtype: string | undefined
): ConfiguredPosition['tags'] {
  return position.tags.filter((tag) => matchesActiveSubtype(tag, activeSubtype ?? ''))
}

export function getConfiguredUnitColumns(
  configuredPositions: unknown,
  activeSubtype: string | undefined
): UnitColumn[] {
  if (!isConfiguredPositionsValid(configuredPositions)) {
    return []
  }

  return configuredPositions.flatMap((position) =>
    getActiveSubtypeTags(position, activeSubtype).map((tag) => ({
      unitKey: getColumnUnitKey(position.position_id, tag.tag_id),
      unitLabel: tag.display_name,
      positionId: position.position_id,
      tagId: tag.tag_id,
    }))
  )
}

export function getCellValueKey(positionId: string, tagId: string, direction: Direction): string {
  return `${positionId}::${tagId}::${direction}`
}

export function getCellKey(hourIndex: number, positionId: string, tagId: string, direction: Direction): string {
  return `${hourIndex}::${positionId}::${tagId}::${direction}`
}

export function parseCellKey(cellKey: string): {
  hourIndex: number
  positionId: string
  tagId: string
  direction: Direction
} | null {
  const [hourRaw, positionId, tagId, direction] = cellKey.split('::')

  if (!hourRaw || !positionId || !tagId || !direction) {
    return null
  }

  const hourIndex = Number(hourRaw)
  if (!Number.isInteger(hourIndex)) {
    return null
  }

  if (direction !== 'buy' && direction !== 'sell') {
    return null
  }

  return {
    hourIndex,
    positionId,
    tagId,
    direction,
  }
}
